/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import ChipButton from 'bundles/search-common/components/experiments/filters2024/ChipButton';

import courseraPlusLogo from 'images/search-common/coursera_plus.png';

import _t from 'i18n!nls/search-common';

type Props = { isActive: boolean; onClick: () => void };
const styles = {
  courseraPlusFilter: css`
    display: flex;
    align-items: center;
  `,
  logoWrapper: css`
    overflow: hidden;
    position: relative;
  `,
};
export const CourseraPlusFilterChipButton = (props: Props): React.ReactElement => {
  const { isActive, onClick } = props;
  return (
    <ChipButton
      onClick={onClick}
      prefix={
        <div css={styles.logoWrapper}>
          <Imgix
            src={courseraPlusLogo}
            maxWidth={80}
            maxHeight={8}
            aria-hidden={true}
            alt={_t('Coursera Plus filter button')}
          />
        </div>
      }
      isActive={isActive}
      isCourseraPlusButton
    />
  );
};

export default CourseraPlusFilterChipButton;
